export const logoBaseURL = 'https://logo.ignosis.ai/';

export enum PortfolioTyoe {
  Banks,
  MF,
  Stocks,
  Deposits,
}
